import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { accountsStateSelector } from "./accountsStateSelector";
import { AccountSortByFields } from "../../accountsSlice";

export const accountsSortBySelector = createDraftSafeSelector(
  [accountsStateSelector],
  (accountsState): AccountSortByFields => accountsState.accountSortBy,
);
